import { service, fileService, formService } from '@/data/index';
/**
 * @function getTeacherList 获取教师列表
 * @param data  教师查询参数对象{}
 * @returns {*}
 */

export function getTeacherList(data) {
  return service.get('school/teacher/listNew', data);
}
/**
 * @function addTeacher 新增教师
 * @param data  教师信息参数对象{}
 * @returns {*}
 */

export function addTeacher(data) {
  return service.post('school/teacher/saveNew', data);
}
/**
 * @function eidtTeacherNameById 根据教师Id修改name
 * @param data  参数对象{name: '教师姓名', teacherId: '教师编号'}
 * @returns {*}
 */

export function eidtTeacherNameById(data) {
  return service.post('school/teacher/updateNew', data);
}
/**
 * @function resetTeacherPwd 批量重置密码
 * @param data  参数对象{ids: '11,22'}
 * @returns {*}
 */

export function resetTeacherPwd(data) {
  return service.get('school/teacher/updatePassword', data);
}
/**
 * @function multiDeleteTeacher 批量删除教师信息
 * @param data  参数对象{ids: '11,22'}
 * @returns {*}
 */

export function multiDeleteTeacher(data) {
  return service.get('school/teacher/batchDelete', data);
}
/**
 * @function setHeaderMaster 设置校长身份
 * @param data  参数对象{}
 * @returns {*}
 */

export function setHeaderMaster(data) {
  return service.get('school/teacher/upgrade2Master', data);
}
/**
 * @function cancelHeaderMaster 设置取消校长身份
 * @param data  参数对象{}
 * @returns {*}
 */

export function cancelHeaderMaster(data) {
  return service.get('school/teacher/change2Teacher', data);
}
/**
 * @function updateTeacherStatus 启用，禁用教师状态
 * @param data  参数对象{}
 * @returns {*}
 */

export function updateTeacherStatus(data) {
  return service.get('school/teacher/updateState', data);
}
/**
 * @function importTeacherFile 教师信息批量导入
 * @param data  参数对象{}
 * @returns {*}
 */

export function importTeacherFile(data) {
  return fileService({
    url: 'school/teacher/importNew',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * @function infoConfirmTeacher 拿取某年级下任课信息
 * @param data  参数对象{}
 * @returns {*}
 */

export function infoConfirmTeacher(data) {
  return service.get('school/school/infoConfirm', data);
}
/**
 * @function getBatchTeachers 获取可选择的已授权教师列表
 * @param data  参数对象{}
 * @returns {*}
 */

export function getBatchTeachers() {
  return service.get('school/teacher/getList');
}
/**
 * @function saveConfirmClassTeacher 班主任、任课教师保存
 * @param data  参数对象{}
 * @returns {*}
 */

export function saveConfirmClassTeacher(data) {
  return service.post('school/class/saveConfirmClassTeacher', data);
}
/**
 * @function deleteConfirmClassTeacher 班主任、任课教师删除
 * @param data  参数对象{}
 * @returns {*}
 */

export function deleteConfirmClassTeacher(data) {
  return service.post('school/class/deleteConfirmClassTeacher', data);
}
/**
 * @function editConfirmClassTeacher 班主任、任课教师修改
 * @param data  参数对象{}
 * @returns {*}
 */

export function editConfirmClassTeacher(data) {
  return service.post('school/class/updateConfirmClassTeacher', data);
}
/* 教师授权 */

/*
 * 教师授权 学校组织结构
 */

export function schorgList() {
  return service.get('school/schOrg/list');
}
/*
 * 教师授权 学校组织结构
 */

export function schorgAdd(data) {
  return service.post('school/schOrg/save', data);
}
/*
 * 学校组织结构删除职务
 */

export function schorgDelete(data) {
  return service.get('school/schOrg/delete', data);
}
/*
 * 获取所有的教师列表
 */

export function schoolTeacherList() {
  return service.get('school/class/teacherList');
}
/*
 * 教师授权列表
 */

export function getOrderTeacher(data) {
  return service.get('school/schOrg/getOrderTeacher', data);
}
/*
 * 教师授权添加
 */

export function addOrderTeacher(data) {
  return service.get('school/schOrg/addOrderTeacher', data);
}
/*
 * 教师授权删除
 */

export function deleteOrderTeacher(data) {
  return service.get('school/schOrg/deleteOrderTeacher', data);
}
/*
 * 获取年级关系列表
 */

export function findhavedSchoolGrade(data) {
  return service.get('school/schOrg/findhavedSchoolGradeBySchOrgCode', data);
}
/*
 * 保存/更新年级老师职称关联
 */

export function saveGradeTeacherByDuty(data) {
  return service.get('school/schOrg/saveSchOrgGrade', data);
}
/*
 * 获取年级列表
 */

export function findAllSchoolOrgcode(data) {
  return service.get('school/schOrg/findAllSchoolGradeByOrgCode', data);
}
/*
 * 获取角色权限列表
 */

export function appRolePermissionGet() {
  return service.get('school/appRolePermission/get');
}
/*
 * 获取组织结构和角色关系列表
 */

export function findRoleBySchorg(data) {
  return service.get('school/schOrg/findRoleBySchOrg', data);
}
/*
 * 保存组织结构和角色关系
 */

export function saveReorgRole(data) {
  return service.get('system/orgRole/saveReOrgRole', data);
}
/*
 * 保存组织结构，年级和角色 接口
 */

export function saveSchOrgRel(data) {
  return service.post('school/schOrg/saveSchOrgRel', data);
}
/* 角色设置 */

/*
 *    获取角色列表
 */

export function roleSetFn(data) {
  return service.post('system/orgRole/getRoleList', data);
}
/*
 *  新增角色
 */

export function addRoleFn(data) {
  return service.post('system/orgRole/add', data);
}
/*
 *  修改角色
 */

export function modifyRole(data) {
  return service.post('system/orgRole/update', data);
}
/*
 *  删除角色
 */

export function deleteRoleFn(data) {
  return service.post('system/orgRole/delete', data);
}
/*
 *  获取权限列表
 */

export function getProductFn(data) {
  // return service.post('school/appRolePermission/findInitPermission',data); //TODO原始动态功能
  return service.post('school/appRolePermission/findPermission', data);
}
/*
 *  设置当前角色的权限
 */

export function setProductFn(data) {
  return formService({
    url: 'school/appRolePermission/setAppPermission',
    method: 'post',
    data: data
  });
}
/*
 *  设置当前角色的权限
 */

export function searchCurRoleProFn(data) {
  return service.get('school/appRolePermission/get', data);
}
/**
 * @description 通过文件导入学生信息
 * @param {file: file} data
 * @returns {*}
 */

export function importTeacherInfoByFile(data) {
  return fileService({
    url: 'school/teacherSubject/import',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/*
 *  导出教师信息
 */

export function dowLoadTeacherUser(data) {
  return formService({
    responseType: 'blob',
    url: '/export/to/dowLoadTeacherUser',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}